export const dictionary = {
    common: {
        ui: {
            menu: {
                main: {
                    sections: {
                        sensors: "Sensori",
                        observations: "Osservazioni",
                        modelling: "Modellazione",
                        mapFeatures: "Caratteristiche della mappa",
                        output: "Esporta & Segnala",
                        setUp: "Configurazione",
                    },
                },
            },
        },
    },
    temporalUnits: {
        millis: { long: { singular: 'millisecondo', plural: 'millisecondi' }, short: { singular: 'mso', plural: 'msi' } },
        seconds: { long: { singular: 'secondo', plural: 'secondi' }, short: { singular: 'seco.', plural: 'seci.' } },
        minutes: { long: { singular: 'minuto', plural: 'minuti' }, short: { singular: 'mino.', plural: 'mini.' } },
        hours: { long: { singular: 'ora', plural: 'ore' }, short: { singular: 'ora.', plural: 'ore.' } },
        days: { long: { singular: 'giorno', plural: 'giorni' }, short: { singular: 'giorno', plural: 'giorni' } },
        weeks: { long: { singular: 'settimana', plural: 'settimane' }, short: { singular: 'settma.', plural: 'settme.' } },
        months: { long: { singular: 'mese', plural: 'mesi' }, short: { singular: 'mese', plural: 'mesi' } },
        quarters: { long: { singular: 'trimestre', plural: 'trimestrale' }, short: { singular: 'tri.', plural: 'tria.' } },
        years: { long: { singular: 'anno', plural: 'anni' }, short: { singular: 'an.', plural: 'ann.' } },
    },
    timezone: "Fuso orario",
    custom: 'modificato',
    period: 'periodo',
};
